/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { LineSegments, Vector3 } from 'three';
let Shape3DLine = class Shape3DLine extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const inf = 1000000; // indefinite line
        const x1 = shape.point.x + shape.direction.x * inf;
        const y1 = shape.point.y + shape.direction.y * inf;
        const z1 = shape.point.z + shape.direction.z * inf;
        const x2 = shape.point.x - shape.direction.x * inf;
        const y2 = shape.point.y - shape.direction.y * inf;
        const z2 = shape.point.z - shape.direction.z * inf;
        const geometry = Solids.createLineSegment(x1, y1, z1, x2, y2, z2);
        if (decoration != null && decoration.LineWidth > 0) {
            this.add(new LineSegments(geometry, CrownShape.getLineMaterial(decoration)));
        }
    }
    format() {
        const { source } = this.transformPose();
        return {
            point: (new Vector3(source.point.x, source.point.y, source.point.z)).applyMatrix4(this.matrix),
            direction: (new Vector3(source.direction.x, source.direction.y, source.direction.z)).applyMatrix4(this.matrix),
        };
    }
};
Shape3DLine = tslib_1.__decorate([
    Shape('Shape3D.Line'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], Shape3DLine);
export { Shape3DLine };
//# sourceMappingURL=Shape3DLine.js.map